import { getSheet } from "../global/api";
import { countfunc } from "../global/count";
import { refresh } from "../global/api";
import locale from "../locale/locale";
import { getSheetIndex } from "../methods/get";
import Store from "../store";
import { luckysheetContainerFocus, mouseclickposition, replaceHtml } from "../utils/util";
import luckysheetConfigsetting from "./luckysheetConfigsetting";
import menuButton from "./menuButton";
import sheetmanage from "./sheetmanage";
import { zoomSetting } from "../global/rhchInit";

/**
 * @description 视觉辅助控制器类 数据项设置 | 护眼模式 | 高亮行列
 *  其他的配置如果想修改的话，需要修改 Store.toJsonOptions 配置项
 */
class VisualAidCtrl {
    static visualAidOptions = {
        cellNum: true,
        count: true,
        avg: true,
        sum: true,
        max: true,
        min: true,
        eyeModeFill: "#cce8cf", // 护眼模式背景颜色
        eyeModeBorderColor: "#c2c2c2", // 护眼模式边框颜色
        eyeMode: false,
        highlight: false,
        highlightColor: "#faf9d2",
    };

    // 缓存当前行高列宽，这是为了实现隐藏行列表头后，还能恢复到原始宽度
    cacheData = {
        rowHeaderWidth: 0,
        columnHeaderHeight: 0,
    };

    init() {
        $("#luckysheet-visual-aid")
            .find(".luckysheet-visual-aid-item")
            .click(function () {
                let type = $(this).attr("type");

                if (type === "data-setting") {
                    return visualAidCtrl.handleDataSettingMenu($(this));
                } else if (type === "eye-mode") {
                    // 切换护眼模式
                    visualAidCtrl.handleEyeMode();
                } else if (type === "highlight-cell") {
                    // 切换高亮行列
                    visualAidCtrl.handleHighlightCell();
                }

                $(this).toggleClass("luckysheet-visual-aid-item-active");
            });

        // 先同步状态
        this.handleOptions();

        // 默认处理一下是否有按钮需要激活
        const { eyeMode, highlight } = Store.visualAidOptions;

        if (eyeMode) {
            const eyeModeContainer = $("#luckysheet-visual-aid").find(".luckysheet-visual-aid-item[type='eye-mode']");
            eyeModeContainer.toggleClass("luckysheet-visual-aid-item-active");
        }

        if (highlight) {
            const highlightContainer = $("#luckysheet-visual-aid").find(".luckysheet-visual-aid-item[type='highlight-cell']");
            highlightContainer.toggleClass("luckysheet-visual-aid-item-active");
        }
    }

    // 初始化数据项配置的二级菜单
    handleDataSettingMenu($t) {
        // 创建二级菜单 luckysheet-icon-data-setting-menuButton
        let menuButtonId = $t.attr("id") + "-menuButton";
        let $menuButton = $("#" + menuButtonId);

        const _locale = locale();
        const locale_visualAid = _locale.visualAid;

        // 指向 visualAid 对象
        let $visualAid = this;

        if ($menuButton.length == 0) {
            let itemdata = [
                { text: locale_visualAid.cellNum, value: "cellNum", example: "" },
                { text: locale_visualAid.grid, value: "grid", example: "" },
                { text: "", value: "split", example: "" },
                { text: locale_visualAid.count, value: "count", example: "" },
                { text: locale_visualAid.sum, value: "sum", example: "" },
                { text: locale_visualAid.avg, value: "avg", example: "" },
                { text: locale_visualAid.max, value: "max", example: "" },
                { text: locale_visualAid.min, value: "min", example: "" },
            ];

            let itemset = menuButton.createButtonMenu(itemdata);

            let menu = replaceHtml(menuButton.menu, {
                id: "data-setting",
                item: itemset,
                subclass: "",
                sub: "",
            });

            $("body").append(menu);
            $menuButton = $("#" + menuButtonId).width(120);

            $menuButton.find(".luckysheet-cols-menuitem").click(async function () {
                // $menuButton.hide(); // 点击菜单项后隐藏二级菜单
                luckysheetContainerFocus();

                let $t = $(this),
                    itemvalue = $t.attr("itemvalue");
                $visualAid.patchItemValue($menuButton, itemvalue);
            });
        }

        // 这个可以实现哪些菜单被选中
        const { cellNum, count, avg, sum, max, min } = Store.visualAidOptions;
        const showGridLines = this.getShowGridLines();

        const activeItems = [];
        if (showGridLines) activeItems.push("grid");
        if (cellNum) activeItems.push("cellNum");
        if (count) activeItems.push("count");
        if (avg) activeItems.push("avg");
        if (sum) activeItems.push("sum");
        if (max) activeItems.push("max");
        if (min) activeItems.push("min");

        menuButton.multiFocus($menuButton, activeItems);

        // 二级菜单的位置
        let userlen = $t.outerWidth();
        let tlen = $menuButton.outerWidth();

        let menuleft = $t.offset().left;
        if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width()) {
            menuleft = menuleft - tlen + userlen;
        }
        mouseclickposition($menuButton, menuleft, $t.offset().top - 15, "leftbottom");
    }

    // 切换护眼模式
    handleEyeMode() {
        // 判断当前是什么状态
        const { eyeMode } = Store.visualAidOptions;
        Store.visualAidOptions.eyeMode = !eyeMode;
        // 刷新表格
        refresh();
        // 同步到 Store.toJsonOptions 上，这里是为了实现导出 json 时，能够包含视觉辅助配置项
        this.syncToJsonOptions();
    }

    // 切换高亮行列
    handleHighlightCell() {
        // 判断当前是什么状态
        const { highlight } = Store.visualAidOptions;
        Store.visualAidOptions.highlight = !highlight;
        // 刷新表格
        refresh();
        // 同步到 Store.toJsonOptions 上，这里是为了实现导出 json 时，能够包含视觉辅助配置项
        this.syncToJsonOptions();
    }

    /**
     * @description 处理视觉辅助配置项点击事件
     * @param {*} itemvalue
     */
    patchItemValue($menuButton, itemvalue) {
        // 切换选中状态
        menuButton.toggleFocus($menuButton, itemvalue);

        // 如果用户点击的是网格线配置
        if (itemvalue == "grid") this.handleShowGridLines();
        else if (itemvalue == "cellNum") this.handleCellNum();
        else {
            // 其他配置项 直接获取状态，然后同步到 Store.visualAidOptions 上即可
            Store.visualAidOptions[itemvalue] = !Store.visualAidOptions[itemvalue];
        }

        // 重新执行 countfunc 函数
        countfunc();
        // 重新刷新表格
        refresh();
        // 同步到 Store.toJsonOptions 上，这里是为了实现导出 json 时，能够包含视觉辅助配置项
        this.syncToJsonOptions();
    }

    /**
     * @description 切换网格线显示状态
     */
    handleShowGridLines() {
        Store.showGridLines = !Store.showGridLines;

        // 更新 sheet config 中的 showGridLines 字段，因为用户可能需要 config 进行数据保存，因此，需要保持一致的状态
        const file = Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)];
        file["showGridLines"] = Store.showGridLines;
    }

    /**
     * @description 切换隐藏行列号
     */
    handleCellNum() {
        // 判断当前的状态
        const { cellNum } = Store.visualAidOptions;
        Store.visualAidOptions.cellNum = !cellNum;

        // 如果要隐藏
        if (cellNum) {
            Store.rowHeaderWidth = 0;
            Store.columnHeaderHeight = 0;
            luckysheetConfigsetting.rowHeaderWidth = 0;
            luckysheetConfigsetting.columnHeaderHeight = 0;
        } else {
            // 恢复数据
            const { rowHeaderWidth, columnHeaderHeight } = this.cacheData;
            luckysheetConfigsetting.rowHeaderWidth = rowHeaderWidth;
            luckysheetConfigsetting.columnHeaderHeight = columnHeaderHeight;
        }

        zoomSetting();
    }

    /**
     * @description 修改高亮行列颜色
     * @param {*} color 颜色颜色
     */
    changeHighlightColor(color) {
        Store.visualAidOptions.highlightColor = color;
        // 刷新表格
        refresh();
        // 同步到 Store.toJsonOptions 上，这里是为了实现导出 json 时，能够包含视觉辅助配置项
        this.syncToJsonOptions();
    }

    /**
     * @description 处理视觉辅助配置项
     */
    handleOptions() {
        // 这获取用户的配置项
        const visualAid = luckysheetConfigsetting.visualAid || {};
        const options = Object.assign({}, VisualAidCtrl.visualAidOptions, visualAid);

        // 最好是将数据存储到 Store 上，进行全部管理
        Store.visualAidOptions = options;

        // 同步到 Store.toJsonOptions 上，这里是为了实现导出 json 时，能够包含视觉辅助配置项
        this.syncToJsonOptions();

        const { rowHeaderWidth = 46, columnHeaderHeight = 20 } = Store;
        this.cacheData = { rowHeaderWidth, columnHeaderHeight };
    }

    /**
     * @description 获取当前是否需要绘制网格线
     */
    getShowGridLines() {
        return Store.showGridLines;
    }

    /**
     * @description 重要方法：同步到 Store.toJsonOptions 上
     */
    syncToJsonOptions() {
        Store.toJsonOptions["visualAid"] = Store.visualAidOptions;
    }
}

export const visualAidCtrl = new VisualAidCtrl();
